import ModalAuthenticationMethod from './ModalAuthenticationMethod';

export default ModalAuthenticationMethod;
